import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import useProtecaoDeRota from '../hooks/useProtecaoDeRota';
import { Spin, message } from 'antd';
import TabelaDados from './Table';
import useApi from '../hooks/useApi';
import ModalDelete from './modal/DeleteDashboardGrupo';
import ModalAdd from './modal/AddDashboardGrupo';


const ListaDashboardsGrupo = ({ idGrupo }) => {
  const verificando = useProtecaoDeRota();
  const [dashboards, setDashboards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const previousDashboardsRef = useRef([]);  // Ref para armazenar dados anteriores

  const { callApi } = useApi(`https://vision.alfama.com/api/view/dashboards/grupo/${idGrupo}`, { 
    includeToken: true,
  });

  const extraColumns = useMemo(() => [
    { id: 'nome', name: 'Dashboard', sort: true, width: '10%' },
    { id: 'has_rls', name: 'RLS', sort: true, mwidth: '5%' },
    { id: 'departamento', name: 'Departamento', sort: true, width: '10%' },
  ], []);

  const showMessage = useCallback((type, content) => {
    message[type](content);
  }, []);

  const formatarDashboards = useCallback((dashboards) => {
    return dashboards.map(dashboard => ({
      id: dashboard.vinculo_id,
      nome: dashboard.nome_dashboard,
      descricao: dashboard.descricao_dashboard,
      has_rls: dashboard.has_rls,
      departamento: dashboard.nome_departamento,
      data_criacao: dashboard.vinculo_data_criacao,
      data_atualizacao: dashboard.vinculo_data_atualizacao,
      status: dashboard.situacao_dashboard,
    }));
  }, []);
  
  const buscarDashboards = useCallback(async () => {
    try {
      const resultado = await callApi();
      const dashboardsFormatados = formatarDashboards(resultado);

      if (JSON.stringify(dashboardsFormatados) !== JSON.stringify(previousDashboardsRef.current)) {
        setDashboards(dashboardsFormatados);
        previousDashboardsRef.current = dashboardsFormatados;
      }
    } catch (erro) {
      console.error('Erro ao buscar dashboards:', erro);
      showMessage('error', 'Não foi possível carregar os dashboards');
    } finally {
      setIsLoading(false);
    }
  }, [callApi, formatarDashboards, showMessage]);

  const handleModalOpen = useCallback((type, id) => {
    setModalType(type);
    setSelectedId(id);
    setModalVisible(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setModalType(null);
    setSelectedId(null);
    buscarDashboards();
  }, [buscarDashboards]);

  const handleDeleteConfirm = useCallback(async (success) => {
    if (success) {
      await buscarDashboards();
    }
    handleModalClose();
  }, [buscarDashboards, handleModalClose]);

  const handleEditConfirm = useCallback(async (success) => {
    if (success) {
      await buscarDashboards();
    }
    handleModalClose();
  }, [buscarDashboards, handleModalClose]);

  const handleAddConfirm = useCallback(async (success) => {
    if (success) {
      await buscarDashboards();
    }
    handleModalClose();
  }, [buscarDashboards, handleModalClose]);

  const getSelectedDashboard = useCallback((id) => {
    return dashboards.find(dash => dash.id === id) || {};
  }, [dashboards]);

  useEffect(() => {
    if (!verificando) {
      buscarDashboards();
    }

    const intervalId = setInterval(() => {
      buscarDashboards();
    }, 300000);

    return () => {
      clearInterval(intervalId);
    };
  }, [buscarDashboards, verificando]);



  return (
    <>
      <TabelaDados 
        data={dashboards} 
        extraColumns={extraColumns}
        onModalOpen={handleModalOpen}
        editarvisualizar={false}
      />

      {modalType === 'delete' && (
        <ModalDelete
          visible={modalVisible}
          id={selectedId}
          onCancel={handleModalClose}
          onConfirm={handleDeleteConfirm}
        />
      )}


      {modalType === 'add' && (
        <ModalAdd
          visible={modalVisible}
          onCancel={handleModalClose}
          onConfirm={handleAddConfirm}
          idGrupo= {idGrupo}

        />
      )}
    </>
  );
};

export default ListaDashboardsGrupo;